import Styled from 'styled-components';

export const SubContainer = Styled.div``;